module.exports = __webpack_public_path__ + "img/mobile-60.2d068b53.png";